import axios from 'axios'
import qs from 'qs'
import { Message, Loading, MessageBox } from 'element-ui'
import router, { resetRouter, asyncRoutes } from '@/router'
import store from '@/store'
import { getToken, setToken, removeToken } from '@/utils/auth'
import { getLoginBadge, removeLoginBadge, getLaterNotice, setLaterNotice } from '@/utils/examineNotice'
import { iframe_src } from '@/configs'
import { blobToJSON } from '@/utils'
import { buryingPointPage } from '@/utils/buryingPoint'

const sever = process.env.ENV_CONFIG;
const whiteList = ['/shopShare', '/personShare', '/poster', '/dingTalkLink', '/login', '/accountLogin', '/screen'];

const CancelToken = axios.CancelToken;
const source = CancelToken.source();

const params = qs.parse(location.search, { ignoreQueryPrefix: true })
if(params.token){
    setToken(params.token)
    location.href = location.origin
}
let queenToken = '',
    loadingCount = 0,
    loadingInstance


router.beforeEach(async (to, from, next) => {
    // source.cancel()
    if(sever === 'prod'){
        buryingPointPage(from, 'end')
    }

    const hasToken = getToken()
    if(hasToken){
        if (to.path === '/login') {
            next({ ...from, replace: true })
        }else{
            if(store.state.user.init){
                next()
            }else{
                // let userInfo = await store.dispatch('user/getInfo', hasToken)
                // global.is_admin = userInfo.is_admin
                global.is_admin = 1
                // queenToken = userInfo.access_token
                let userInfo = await store.dispatch('user/getUserInfo')
                let generateRoutes = await store.dispatch('user/generateRoutes')

                // resetRouter()
                router.addRoutes(generateRoutes)
                next({ ...to, replace: true })
            }
        }
    }else{
        if(whiteList.includes(to.path)){
            next()
        }else{
            // location.replace(iframe_src)
            next('/login')
        }
    }
})

router.afterEach((to, from) => {
    if(to.meta && to.meta.btnPermissions){
        store.commit('user/SET_BTN_PERMISSIONS', to.meta.btnPermissions)
    }else{
        store.commit('user/SET_BTN_PERMISSIONS', [])
    }
    const hasLoginBadge = getLoginBadge()
    if(hasLoginBadge){
        removeLoginBadge()
        if(store.state.user.signCount && !getLaterNotice()){
            MessageBox.confirm(`您有 ${store.state.user.signCount} 张待审核的补签工单，请及时处理！以免影响直播人员的业绩、时长分配`, '补签审核提醒', {
                customClass: 'el-message-box_alert',
                distinguishCancelAndClose: true,
                closeOnClickModal: false,
                closeOnPressEscape: false,
                confirmButtonText: '立即处理',
                cancelButtonText: '今日不再提醒',
                center: true
            }).then(() => {
                router.push({
                    path: '/examine/appendTime',
                    query: {
                        from: 'dialog'
                    }
                })
            })
            .catch(action => {
                if(action === 'cancel'){
                    setLaterNotice()
                }
            })
        }
    }
    if(sever === 'prod'){
        buryingPointPage(to, 'start')
    }
})


axios.interceptors.request.use(config => {
    if(config.loading){
        loadingHandler(1)
    }
    config.cancelToken = source.token

    if(config.url !== '/api/login'){
        config.headers.Authorization = 'Bearer ' + getToken()
    }
    return config
}, error => {
    // loadingHandler(-1)
    return Promise.reject(error);
})

axios.interceptors.response.use(async response => {
    if(response.config.loading){
        loadingHandler(-1)
    }

    if(response.config.responseType === 'blob'){
        if(response.data.type === 'application/json'){
            response.data = await blobToJSON(response.data)
        }else{
            return response.data
        }
    }
    switch(response.data.status){
        case '401':
            removeToken()
            router.go(0)
            break
        case 200:
            return response.data
        case '':
            return response.data
        default:
            Message({
                message: response.data.msgInfo,
                type: 'error'
            })
            return response.data
    }
}, error => {
    // loadingHandler(-1)
    // Message({
    //     message: error.message,
    //     type: 'error'
    // })
    return Promise.reject(error)
})


let loadingTimer
function loadingHandler(type){
    if(type == 1){
        clearTimeout(loadingTimer)
        if(loadingCount == 0){
            loadingInstance = Loading.service({
                lock: true,
                text: '',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.2)',
                customClass: 'api-loading'
            })
        }
        loadingCount++
    }else if(type == -1){
        loadingCount--
        loadingTimer = setTimeout(() => {
            if(loadingCount == 0){
                loadingInstance.close()
            }
        })
    }
}



// WEBPACK FOOTER //
// ./src/intercept.js